export default function Resume() {
  return (
    <main>
      <section id="resume">
        <h1>Resume</h1>
        {/* Resume content goes here */}
      </section>
    </main>
  );
}
